import { ReplyWithFileParam, UploadFileParam } from '@@types/Api/File';
import Channel from '@@types/Channel';
import { CHANNEL_ID, FILE_ID } from '@@types/common';
import { FileLog, ReplyLog } from '@@types/Log';

import { URLS } from '~/constants';
import { FILE_SEND_TIMEOUT } from '~/constants/api';
import Api2 from '~/stores/providers/Api2';
import { getContents } from '~/utils/apiUtil';
import axios from 'axios';
import { forOwn } from 'lodash';

class FileApi {
  constructor(private api: Api2) {}

  uploadFile = ({ fileDummyLog, onUploadProgress }: UploadFileParam): Promise<FileLog> => {
    const { _attach, file, channelId, token } = fileDummyLog;
    const source = axios.CancelToken.source();
    const cancelToken = source.token;
    const data = new FormData();
    const { fileName, mimeType } = file;

    forOwn(
      {
        attach: _attach,
        fileName,
        mimeType,
        token,
      },
      (value: any, key: string) => data.append(key, value)
    );

    return this.api.contentsRequester.post(`${URLS.API}/channel/${channelId}/file`, data, {
      cancelToken,
      onUploadProgress: ({ loaded, total }) => {
        const progressRatio = loaded / total;
        return onUploadProgress(Math.round(progressRatio * 100));
      },
      timeout: FILE_SEND_TIMEOUT,
    });
  };

  replyWithFile = ({ targetLog, fileDummyLog, onUploadProgress }: ReplyWithFileParam): Promise<ReplyLog> => {
    const { _attach, file, token, channelId } = fileDummyLog;
    const source = axios.CancelToken.source();
    const cancelToken = source.token;
    const data = new FormData();
    const { fileName, mimeType } = file;

    forOwn(
      {
        attach: _attach,
        fileName,
        mimeType,
        token,
      },
      (value: string, key: string) => data.append(key, value)
    );

    return this.api.contentsRequester.post(`${URLS.API}/channel/${channelId}/logs/${targetLog.id}/reply-file`, data, {
      cancelToken,
      onUploadProgress: ({ loaded, total }) => {
        const progressRatio = loaded / total;
        return onUploadProgress(Math.round(progressRatio * 100));
      },
      timeout: FILE_SEND_TIMEOUT,
    });
  };

  getImageMeta = (
    channelId: CHANNEL_ID,
    imageId: FILE_ID
  ): Promise<{
    id: FILE_ID;
    name: string;
    mimetype: string;
    size: number;
    orientation: string;
  }> => {
    return this.api.contentsRequester.get(`${URLS.V2_API}/channel/${channelId}/file/${imageId}?type=meta`);
  };

  checkFileAcl = (channelId: CHANNEL_ID, fileId: FILE_ID): Promise<string> => {
    return this.api.contentsRequester.get(`${URLS.API}/channels/${channelId}/files/${fileId}/acl`);
  };

  checkWebFileAcl = (channelId: CHANNEL_ID, fileId: FILE_ID): Promise<string | undefined> => {
    return this.api.ignoreErrorRequester
      .get(`${URLS.API}/channels/${channelId}/files/${fileId}/web-acl`)
      .then(getContents) as Promise<string | undefined>;
  };

  uploadChannelImage = (channelId: CHANNEL_ID, image: File): Promise<Channel> => {
    const data = new FormData();
    data.append('attach', image);
    return this.api.contentsRequester.post(`${URLS.API}/channels/${channelId}/image`, data);
  };
}

export default FileApi;
